import { LinkField, RichTextField, Field } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type C24LocationCardsProps = RenderingProps<C24LocationCardsFields, C24LocationCardsParams>;

export type C24LocationCardsFields = {
  Headline?: Field<string>;
  SupportCopy: RichTextField;
  SupportCopyBottom: RichTextField;
  CTA?: LinkField;
  SecondCTA?: LinkField;
};

export type C24LocationCardsParams = {
  HeadlineTag?: string;
  ContentAlignment?: string;
  BackgroundColor?: string;
  NumberOfColumns?: string;
  CTAAlignment?: string;
  CTAStyle?: string;
  SecondCTAStyle?: string;
} & DynamicPlaceholderParams &
  AnchorTargetParams &
  TranslationOptionsParams;
